module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"root":["AWSCognito","CognitoIdentityServiceProvider"],"commonjs2":"aws-sdk/clients/cognitoidentityserviceprovider","commonjs":"aws-sdk/clients/cognitoidentityserviceprovider","amd":"aws-sdk/clients/cognitoidentityserviceprovider"}
// module id = 13
// module chunks = 0